import React from 'react';
import './newsHero.scss';
import IMAGE_1 from "../../../../assets/news/news_header_1.png";
import IMAGE_2 from "../../../../assets/news/news_header_2.png";
import IMAGE_3 from "../../../../assets/news/news_header_3.png";
import {HeadingElement} from "../../../../components";


const NewsHero = () => {
    return (
        <div className={'news-hero'}>

            <div className="news-hero_top">
                <img className="news-hero_top_image_1" src={IMAGE_1} alt=""/>
                <img className="news-hero_top_image_2" src={IMAGE_2} alt=""/>
                <img className="news-hero_top_image_3" src={IMAGE_3} alt=""/>
            </div>
            <div className="news-hero_bottom max">
                <div className="news-hero_bottom_wrapper">
                    <HeadingElement/>
                    <h1>Business News & Articles</h1>
                </div>
            </div>

        </div>
    );
};

export default NewsHero;
